<template>
  <div>
    <div class="col-md-12">
      <modal :show.sync="modalShow" class="row" :showClose="true">
        <template slot="header">
          <h5 class="modal-title sub_title" id="exampleModalLabel">Crear Usuario</h5>
        </template>
        <div>

          <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="onSubmit">
              <div class="row user-form">
                <div class=" col-3">
                  <ValidationProvider name="user.client_type_id" rules="required"
                                      v-slot="{ errors }">
                    <label id="user_type_id" class="typo__label">Tipo de Usuario</label>
                    <multiselect v-model="user.user_type_id.user_type_id"
                                 track-by="user_type_id"
                                 label="user_type_name"
                                 placeholder="Seleccione una opción"
                                 :options="user_type"
                                 :searchable="false"
                                 :allow-empty="false"
                    >
                    </multiselect>
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-3 form-group">

                  <ValidationProvider v-if="viewclient" name="user.client_type_id"
                                      v-slot="{ errors }">
                    <label id="client_type_id" class="typo__label">Tipo de cliente</label>
                    <multiselect v-model="user.client_type_id.client_type_id"
                                 track-by="client_type_id"
                                 label="client_type_name"
                                 placeholder="Seleccione una opción"
                                 :options="client_type"
                                 :searchable="false"
                                 :allow-empty="true"
                    >
                    </multiselect>
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-6">
                  <div v-if="viewrestaurant === true">
                    <label class="typo__label">Restaurantes</label>
                    <multiselect v-model="user.restaurant" :options="restaurants" :multiple="true"
                                 group-values="children" group-label="name"
                                 :group-select="true" placeholder="Buscar o agregar uno nuevo"
                                 track-by="name"
                                 label="name">
                      <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                    </multiselect>
                  </div>
                  <div v-if="viewhogar === true">
                    <label class="typo__label">Repartidor</label>
                    <multiselect
                        v-model="dealer"
                        :options="dealers"
                        :custom-label="customLabel"
                        :searchable="true"
                        :multiple="false"
                        :close-on-select="true"
                        track-by="user_id" label="last_name"
                        placeholder="Seleccionar uno">
                    </multiselect>
                  </div>
                </div>
                <div class="col-4">
                  <label for="name">Nombre</label>
                  <ValidationProvider name="user.name" rules="required" v-slot="{ errors }">
                    <input
                        id="name"
                        v-model="user.name"
                        type="text"
                        class="form-control"
                        placeholder="Nombre"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-4">
                  <label for="last_name">Apellido</label>
                  <ValidationProvider name="user.last_name" v-slot="{ errors }">
                    <input
                        id="last_name"
                        v-model="user.last_name"
                        type="text"
                        class="form-control"
                        placeholder="Apellido"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-4" v-if="viewrestaurant === false">
                  <ValidationProvider name="discount_id" rules="required"
                                      v-slot="{ errors }">
                    <label class="typo__label">Descuento</label>
                    <multiselect
                        v-model="selectdiscount"
                        :options="descounts"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        label="description"
                        placeholder="Seleccionar un descuento"
                        class="mt-2"
                    >

                    </multiselect>
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-4" v-if="viewhogar === true">
                  <label for="name">Id Cliente</label>
                  <input
                      id="idcliente"
                      v-model="user.reference_id"
                      type="number"
                      class="form-control"
                      placeholder="Id Cliente"
                  >
                </div>
                <div class="col-4" v-if="viewrestaurant === false">
                  <label for="name">Documento</label>
                  <input
                      id="docuemento"
                      v-model="user.document"
                      type="number"
                      class="form-control"
                      placeholder="Documento"
                  >
                </div>
                <div class="col-4">
                  <label for="phone">Teléfono</label>
                  <ValidationProvider name="user.phone" v-slot="{ errors }">
                    <input
                        id="phone"
                        v-model="user.phone"
                        type="number"
                        class="form-control"
                        placeholder="Telefono"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="col-4">
                  <label for="city">Ciudad</label>
                  <input
                      id="city"
                      v-model="city"
                      type="text"
                      class="form-control"
                      placeholder="Ciudad"
                  >
                </div>
                <div class="col-4">
                  <label for="neighborhood">Barrio</label>
                  <input
                      id="neighborhood"
                      v-model="neighborhood"
                      type="text"
                      class="form-control"
                      placeholder="Barrio"
                  >
                </div>
                <div class="col-4">
                  <label for="phone">Dirección</label>
                  <input
                      id="address"
                      v-model="address"
                      type="text"
                      class="form-control"
                      placeholder="Dirección"
                  >
                </div>
                <div class="col-4">
                  <label for="email">Correo</label>
                  <ValidationProvider name="user.email" rules="required" v-slot="{ errors }">
                    <input
                        id="email"
                        v-model="user.email"
                        type="email"
                        class="form-control"
                        placeholder="Correo"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <!-- <div class="col-4">
                     <label for="user_login">Usuario</label>
                     <ValidationProvider name="user.user_login" rules="required|user_login"
                                         v-slot="{ errors }">
                         <input
                                 id="user_login"
                                 v-model="user.user_login"
                                 type="text"
                                 class="form-control"
                                 placeholder="Usuario"
                         >
                         <p>{{ errors[0] }}</p>
                     </ValidationProvider>
                 </div>-->
                <div class="col-4">
                  <label for="user_pass">Contraseña</label>
                  <ValidationProvider name="user.user_pass" v-slot="{ errors }">
                    <input
                        id="user_pass"
                        v-model="user.user_pass"
                        type="password"
                        class="form-control"
                        placeholder="Contraseña"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label> Estado del usuario</label>
                    <div class="btn-group" role="group">
                      <PrettyRadio name="tp_usuario" v-model="user.user_status" :value="true">Activo</PrettyRadio>
                      <PrettyRadio name="tp_usuario" v-model="user.user_status" :value="false">Desactivado</PrettyRadio>
                    </div>
                  </div>
                  <div class="col-6 ">
                    <base-button id="btn_create" type="primary btn_submit" v-show="btn_create" @click="create()"
                                 :disabled="invalid">Crear
                    </base-button>
                    <base-button id="btn_update" type="primary btn_submit" v-show="btn_update" @click="update()"
                                 :disabled="invalid">Aceptar
                    </base-button>
                  </div>

                </div>
              </div>

            </form>
          </ValidationObserver>
        </div>
        <template slot="footer">
          <base-alert type="danger" v-if="error">
            <strong>{{ error }}</strong>
          </base-alert>
        </template>
        <div class="row">
          <div class="col-12">
            <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                           label="Guardando">
            </base-progress>
          </div>
        </div>
      </modal>
    </div>
  </div>


</template>
<script>

import {bus} from './bus-user'
import {extend, ValidationProvider} from 'vee-validate'
import {ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import {user_service} from "../../services/user/UserService";
import swal from 'sweetalert';
import _ from "lodash";
import PrettyRadio from 'pretty-checkbox-vue/radio';

// register globally

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})
var val_users
var resemail
var email
extend('email', (value) => {
  const re = /\S+@\S+\.\S+/

  resemail = _.filter(val_users, (r) => {
    if (r.email === value) {
      return r
    }
  })
  if (re.test(String(value).toLowerCase())) {
    if (resemail != undefined) {
      if (resemail.length > 0) {
        if (email != undefined && email === value) {
          return true
        } else {
          return 'Email ya existe'
        }
      } else {
        return true
      }
    } else {
      return true
    }
  } else {
    return 'Email no valido'
  }
})

var res
var id
extend('user_login', (value) => {
  user_service.GetValidateUser(value)
  bus.$on('GetValdateUser', (response) => {
    if (response.length >= 1) {
      if (response[0]['user_login'] === value && id === response[0]['user_id']) {
        res = true
      } else {
        res = false
      }
    } else {
      res = true
    }

  })

  if (res === true || value) return true
  return "Usuario Invalido"

})
export default {
  name: 'CreateUser',
  components: {ValidationProvider, ValidationObserver, PrettyRadio},
  data() {
    return {
      error: '',
      viewhogar: false,
      viewuser: true,
      dealer: [],
      dealers: [],
      progress: 0,
      valide_user: false,
      btn_update: false,
      btn_create: true,
      selected: '',
      selectdiscount: {discounts_id: 1, percent: 0, name: 'L1', description: 'Sin Descuento'},
      modalShow: false,
      descounts: [],
      user_type: [],
      client_type: [],
      address: '',
      city: '',
      neighborhood: '',
      deliver_to: '',
      observation: '',
      user: {
        name: '',
        last_name: '',
        phone: '',
        email: '',
        user_pass: '',
        user_login: 'null',
        user_status: 0,
        dealer: null,
        client_type_id: {
          client_type_id: null,
        },
        user_type_id: {
          user_type_id: null,
        },
        restaurant: [],
        shipping_address: '',
        reference_id: 0,
        document: '',
        Discounts: 0
      },
      user_edit: {
        user_id: 0,
        name: '',
        last_name: '',
        phone: '',
        email: '',
        user_status: 0,
        dealer: null,
        client_type_id: {
          client_type_id: null,
        },
        user_type_id: {
          user_type_id: null,
        },
        restaurant: [],
        shipping_address: '',
        reference_id: 0,
        document: '',
        Discounts: 0
      },
      restaurant_user: [],
      restaurants: [],
      users: {},
      viewclient: false,
      viewrestaurant: false,
      pass_encry: ''


    }
  },
  watch: {
    'user.user_type_id.user_type_id': function () {
      if (this.user.user_type_id.user_type_id != undefined) {
        if (this.user.user_type_id.user_type_id.user_type_name === 'Repartidor') {
          this.viewclient = false
          this.viewrestaurant = false
          this.user.restaurant = []
          this.user_edit.restaurant = []
          this.viewhogar = true
          this.viewuser = false
        } else if (this.user.user_type_id.user_type_id.user_type_name === 'Despachador') {
          this.viewclient = false
          this.viewrestaurant = false
          this.user.restaurant = []
          this.user_edit.restaurant = []
          this.viewhogar = false
          this.viewuser = true
        } else if (this.user.user_type_id.user_type_id.user_type_name) {
          this.viewclient = true
          this.viewuser = false
        }
      }
    },
    'user.client_type_id.client_type_id': function () {
      //console.log(this.user.client_type_id.client_type_id)
      if (this.user.client_type_id.client_type_id.client_type_id === 1) {
        this.viewrestaurant = false
        this.user.restaurant = []
        this.user_edit.restaurant = []
        this.viewhogar = true
      }
      if (this.user.client_type_id.client_type_id.client_type_id === 2) {
        this.viewrestaurant = true
        this.viewhogar = false
      }
    }
  },
  methods: {
    restausers(data) {
      return _.filter(data, (r) => {
        if (r.restaurant_id > 0) {
          return r.restaurant_id
        }


      })
    },
    onSubmit() {
      alert('Form has been submitted!');
    },
    showModal() {
      this.address = ''
      this.modalShow = !this.modalShow
      id = 0
      email = ''
    },
    customLabel({name, last_name}) {
      return `${name} ${last_name}`
    },
    create() {
      try {

        if (this.user.user_status === true) {
          this.user.user_status = 1
        } else {
          this.user.user_status = 0
        }
        if (this.user.user_type_id.user_type_id.user_type_id != undefined) {
          this.user.user_type_id.user_type_id = this.user.user_type_id.user_type_id.user_type_id
        } else {
          this.user.user_type_id.user_type_id = null
        }
        if (this.user.client_type_id.client_type_id.client_type_id != undefined) {
          this.user.client_type_id.client_type_id = this.user.client_type_id.client_type_id.client_type_id
        } else {
          this.user.client_type_id.client_type_id = null
        }
        if (this.viewhogar === true) {
          this.user.dealer = this.dealer.user_id
        }
        if (this.selectdiscount) {
          this.user.Discounts = this.selectdiscount.discounts_id
        } else {
          this.user.Discounts = null
        }

        this.user.shipping_address = JSON.stringify([{
          'address': this.address,
          'phone': this.user.phone,
          'observation': '',
          'deliver_to': 'Persona',
          'neighborhood': this.neighborhood,
          'city': this.city
        }])

        if (this.user.user_pass != '') {
          this.error = ''
          this.progress = 50
          user_service.CreateUser(this.user)
        } else {
          this.error = 'Ingresa una contraseña'
        }


      } catch (e) {
        return e
      }
    },
    update() {
      if (this.user_edit.user_id > 0) {
        this.progress = 50
        try {
          if (this.user.user_status === true) {
            this.user_edit.user_status = 1
          } else {
            this.user_edit.user_status = 0
          }
          this.user_edit.name = this.user.name
          this.user_edit.last_name = this.user.last_name
          this.user_edit.phone = this.user.phone
          this.user_edit.email = this.user.email
          this.user_edit.document = this.user.document
          this.user_edit.reference_id = this.user.reference_id
          if (this.selectdiscount) {
            this.user_edit.Discounts = this.selectdiscount.discounts_id
          } else {
            this.user_edit.Discounts = null
          }
          if (this.user.user_pass != '') {
            this.user_edit.user_pass = this.user.user_pass
          }
          if (this.user.user_type_id.user_type_id.user_type_id != undefined) {
            this.user_edit.user_type_id.user_type_id = this.user.user_type_id.user_type_id.user_type_id
          } else {
            this.user_edit.user_type_id.user_type_id = null
          }
          if (this.user.client_type_id.client_type_id.client_type_id != undefined) {
            this.user_edit.client_type_id.client_type_id = this.user.client_type_id.client_type_id.client_type_id
          } else {
            this.user_edit.client_type_id.client_type_id = null
          }
          if (this.viewhogar === true) {
            //console.log(this.dealer)
            this.user_edit.dealer = this.dealer.user_id
          }
          this.user_edit.shipping_address = JSON.stringify([{
            'address': this.address,
            'phone': this.user.phone,
            'observation': this.observation,
            'deliver_to': this.deliver_to,
            'neighborhood': this.neighborhood,
            'city': this.city
          }])

          this.user_edit.restaurant = this.user.restaurant
          user_service.UpdateUser(this.user_edit)
        } catch (e) {
          console.log(e)

        }


      }
    },
    responsecreate(response) {
      if (response.statusText === "Created") {
        user_service.GetAllUsers()
        this.progress = 100
        this.cleanform()
        this.showModal()
        swal({
          icon: "success",
          text: "Usuario Registrado Correctamente",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        swal({
          dangerMode: true,
          icon: "error",
          text: "Usuario No se Ha Registrado Correctamente",
          button: "Aceptar"
        })
        user_service.GetAllUsers()
      }
      this.getdata()
    },
    async getdata() {
      user_service.GetAllUsers(3)
      user_service.GetAllRestaurant()
      user_service.GetUserType()
      user_service.GettypeClient()
      user_service.GetAllDiscounts()
      bus.Getdata()
    },
    responseupdate(response) {

      if (response.status === 200) {
        user_service.GetAllUsers()
        this.progress = 100
        this.cleanform()
        this.showModal()
        swal({
          icon: "success",
          text: "Usuario Actualizado Correctamente",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        swal({
          dangerMode: true,
          icon: "error",
          text: "No se Actualizo el Usuario Registrado Correctamente",
          button: "Aceptar"
        })
      }
      this.getdata()
    },
    cleanform() {
      this.progress = 0
      this.user.name = ''
      this.user.last_name = ''
      this.user.phone = ''
      this.user.email = ''
      this.user.user_login = ''
      this.user.user_pass = ''
      this.user.user_status = 0
      this.user.client_type_id.client_type_id = 0
      this.user.user_type_id.user_type_id = 0
      this.user.restaurant = []
      this.user.document = ''
      this.user.reference_id = 0
      this.user.Discounts = 0
      this.user.dealer = null
      this.user_edit = {
        user_id: 0,
        name: '',
        last_name: '',
        phone: '',
        email: '',
        user_status: 0,
        dealer: null,
        client_type_id: {
          client_type_id: 0,
        },
        user_type_id: {
          user_type_id: 0,
        },
        restaurant: [],
        shipping_address: '',
        reference_id: 0,
        document: '',
        Discounts: 0
      }
      this.viewclient = false
      this.viewrestaurant = false
      this.viewhogar = false
      this.dealer = []
      //user_service.GetAllUsers()
    },
    valemail(value) {
      const e = _.filter(this.users, (r) => {
        if (r.email === value) {
          return r
        }
      })
      if (e.length > 0) {
        return false
      } else {
        return true
      }
    }
  },
  created() {
    this.getdata()
    user_service.GetAllUsersVal()
    bus.$on('GetAllUserVal', (users) => {
      val_users = users
    })
    bus.$on('GetAllDiscounts', (response) => {
      this.descounts = response
    })
    bus.$on('ShowModal', () => {
      this.btn_create = true
      this.btn_update = false
      this.cleanform()
      this.showModal()
    })
    bus.$on('AllTypeUser', (user_type) => {
      this.user_type = user_type
    })
    bus.$on('AllTypeClient', (client_type) => {
      this.client_type = client_type
    })
    bus.$on('ResponseCreateUser', (response) => {
      this.responsecreate(response)
    })
    bus.$on('ResponseUpdateUser', (response) => {
      this.responseupdate(response)
    })
    bus.$on('GetAllCity', (response) => {
      this.City = response
    })
    bus.$on('GetAllDealer', (response) => {
      this.dealers = response
    })
    bus.$on('GetValdateMail', (response) => {
      console.log(response)
    })
    bus.$on('GetAllRestaurant', (restaurants) => {
      this.restaurants = restaurants
    })
    bus.$on('GetEditUser', (useredit) => {
      this.showModal();
      id = useredit.user_id
      email = useredit.email
      this.btn_create = false
      this.btn_update = true
      this.user_edit.user_id = useredit.user_id
      this.user.name = useredit.name
      this.user.last_name = useredit.last_name
      this.user.phone = useredit.phone
      this.user.email = useredit.email
      //this.user.user_login = useredit.user_login
      //this.user.user_pass = useredit.user_pass
      this.pass_encry = useredit.user_pass
      this.user.reference_id = useredit.reference_id
      this.user.document = useredit.document
      this.user.dealer = useredit.dealer
      this.selectdiscount = useredit.Discounts

      if (useredit.shipping_address != '') {
        let shopping = JSON.parse(useredit.shipping_address)
        this.address = shopping[0].address
        this.city = shopping[0].city
        this.neighborhood = shopping[0].neighborhood
        this.deliver_to = shopping[0].deliver_to
        this.observation = shopping[0].observation
      }

      if (useredit.user_status === 1) {
        this.user.user_status = true
      } else {
        this.user.user_status = false
      }
      if (typeof useredit.client_type_id === undefined) {
        console.log()
      } else {
        this.user.client_type_id.client_type_id = useredit.client_type_id
        if (useredit.client_type_id.client_type_id === 1) {
          this.viewrestaurant = false
          this.viewhogar = true
        } else {
          this.user.restaurant = useredit.restaurant
        }
      }

      this.user.user_type_id.user_type_id = useredit.user_type_id

      if (this.user.dealer > 0) {
        const dealer = _.filter(this.dealers, (u) => {
          return u.user_id === this.user.dealer
        })
        this.dealer = dealer
      }

    })


  }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>

<style scoped>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .user-form {
    display: block;
  }

  .user-form > div {
    flex: 100%;
    max-width: 100%;
    margin: 10px auto;
  }

  .user-form > div label {
    width: 100%;
    text-align: left;
  }

  .user-form > div .radio-default-acre {
    margin-bottom: 3em;
    display: flex;
  }

  .modal {
    width: auto;
  }
}
</style>
